import Collection from '../../utils/Collection';

import {
  FETCH_TUTORS_ON_SLOT_SENT,
  FETCH_TUTORS_ON_SLOT_SUCCEEDED,
  FETCH_TUTORS_ON_SLOT_FAILED,
  CLEAR_TUTORS_ON_SLOT,
} from '../../actions/timeslot';

const initialState = {
  loading: false,
  tutors: [],
  count: 0,
};

export default function tutorsOnSlotReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case CLEAR_TUTORS_ON_SLOT:
      return initialState;
    case FETCH_TUTORS_ON_SLOT_SUCCEEDED:
      return {
        ...state,
        loading: false,
        count: payload.total,
        tutors: Collection.reset(state.tutors, payload.tutors),
      };
    case FETCH_TUTORS_ON_SLOT_FAILED:
      return {
        ...state,
        loading: false,
        tutors: [],
        count: 0,
      };
    case FETCH_TUTORS_ON_SLOT_SENT:
      return {
        ...state,
        loading: true,
        tutors: [],
        count: 0,
      };
    default:
      return state;
  }
}
